module.exports = __webpack_public_path__ + "static/media/welcome-realistic-voiceover.3ca283c7.svg";